import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import SimpleMap from "../../../components/gmaps";
import Modal from "react-modal";

import { toast } from "react-toastify";
import { Button } from "antd";
const CollectionCentersForm = (props) => {
  const frmRef = useRef({});
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const [warehosuedata, setWarehosuedata] = useState([]);

  const [collectiondata, setCollectiondata] = useState([]);

  const [warehouseId, setWarehouseId] = useState();
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [warehosuelatLong, setWarehosuelatLong] = useState({
    lat: "",
    lng: "",
  });

    useEffect(() => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          //console.log(lat, long);
          setWarehosuelatLong({ lat, lng });
        },
        (error) => {
          console.error(error);
        }
      );
    }, []);

  const [latLongclose, setLatLongclose] = useState(false);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // //console.log("emp", data.output);
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const handleLatLong = () => {
    setLatLongclose(true);
  };

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        url: `/api/warehouses/?orgId=${localStorage.getItem(
          "orgId"
        )}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //  //console.log(res);
          setWarehosuedata(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getCollectionCenterData } = useHttp();

  const getCollectionCenterDetail = () => {
    getCollectionCenterData(
      {
        url: "/api/collectionCenter/",
      },
      (res) => {
        if (res) {
          //  //console.log(res);
          setCollectiondata(res);
        }
      }
    );
  };

  useEffect(() => {
    getCollectionCenterDetail();
  }, [getCollectionCenterData]);

  const { sendRequest: postCollectionCenter } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      name: frmRef.current.collectionCenterName.value.trim(),
      code: frmRef.current.collectionCenterCode.value.trim(),
      SupervisorEmployeeId: frmRef.current.emp_id.value,
      address: frmRef.current.collectionCenter_address.value,
      store_type_id: 1,
      warehouseId: frmRef.current.warehouseId.value,
      city: frmRef.current.city.value,
      state: frmRef.current.state.value,
      zipCode: frmRef.current.zipcode.value,
      country: frmRef.current.country.value,
      contactWork: frmRef.current.work_contact_number.value,
      whatsapp: frmRef.current.whatsapp.value,
      emailId: frmRef.current.email_id.value,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      created_by: parseInt(localStorage.getItem("id")),
      collectionCenterLatLong: warehosuelatLong,
      created_date: new Date(),
      serviceId: props.sId, 

    };

    if (props.update) {
      data["id"] = props.update.id;
    }

    postCollectionCenter(
      {
        url: "/api/collectionCenter/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Collection center detail added`);
        getCollectionCenterDetail();

        frmRef.current.collectionCenterName.value = "";
        frmRef.current.collectionCenterCode.value = "";
        frmRef.current.emp_id.value = "";
        frmRef.current.collectionCenter_address.value = "";

        frmRef.current.city.value = "";
        frmRef.current.state.value = "";
        frmRef.current.zipcode.value = "";
        frmRef.current.country.value = "";
        frmRef.current.work_contact_number.value = "";
        frmRef.current.whatsapp.value = "";
        frmRef.current.email_id.value = "";

        setEmployeeId("--Select Employee--");

        frmRef.current.emp_id.value = "--Select Employee--";

        setWarehouseId("--Select Warehouse--");

        frmRef.current.warehouseId.value = "--Select Warehouse--";
        props.addForm(false);
      }
    );
  };

  useEffect(() => {
    console.log(props.update);
    if (props.update) {
      console.log(props.update.zipcode);
      frmRef.current.collectionCenterName.value = props.update.name;
      frmRef.current.collectionCenterCode.value = props.update.code;
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      setEmployeeId(props.update.SupervisorEmployeeId);
      setWarehouseId(props.update.warehouseId);
      frmRef.current.collectionCenter_address.value = props.update.address;
      frmRef.current.city.value = props.update.city;
      frmRef.current.state.value = props.update.state;
      frmRef.current.zipcode.value = props.update.zipCode;
      frmRef.current.country.value = props.update.country;
      frmRef.current.work_contact_number.value = props.update.contactWork;
      frmRef.current.whatsapp.value = props.update.whatsapp;
      frmRef.current.email_id.value = props.update.emailId;

      setWarehosuelatLong(warehosuelatLong);
      // frmRef.current.collectionCenter_address.value = props.update.

      // setSeasonName(props.update.seasonName);

      // setStartMonth(props.update.seasonStartMonth);

      // setEndMonth(props.update.seasonEndMonth);

      // setDescription(props.update.description);
    }
  }, [props.update]);
  return (
    <>
      {latLongclose && (
        <Modal onClose={setLatLongclose} isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={warehosuelatLong.lat}
            lng={warehosuelatLong.lng}
            set={setWarehosuelatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}{" "}
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Collection Center Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Collection Center Code</label>

                        <input
                          id="collectionCenterCode"
                          type="text"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["collectionCenterCode"] = el)
                          }
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Collection Center Name </label>

                        <input
                          type="text"
                          id="collectionCenterName"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["collectionCenterName"] = el)
                          }
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Assigned Supervisor</label>
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["emp_id"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            setEmployeeId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Employee</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option
                                key={x.userId}
                                x
                                employee-id={x.userId}
                                value={x.userId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Warehosue </label>
                        <select
                          id="warehouseId"
                          className="form-control"
                          ref={(el) => (frmRef.current["warehouseId"] = el)}
                          value={warehouseId}
                          onChange={(e) => {
                            setWarehouseId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Warehouse</option>
                          {warehosuedata &&
                            warehosuedata.map((x) => (
                              <option
                                key={x.id}
                                warehouse-id={x.id}
                                value={x.id}
                              >
                                {x.name} {}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Collection Center Address</label>
                        <input
                          type="text"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["collectionCenter_address"] = el)
                          }
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>City </label>
                        <input
                          type="text"
                          id="city"
                          className="form-control"
                          ref={(el) => (frmRef.current["city"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> State/Province/Region</label>
                        <input
                          type="text"
                          id="state"
                          className="form-control"
                          ref={(el) => (frmRef.current["state"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Country </label>
                        <input
                          type="text"
                          id="country"
                          className="form-control"
                          ref={(el) => (frmRef.current["country"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Zip Code (Postal Code) </label>
                        <input
                          type="text"
                          id="zip_code"
                          className="form-control"
                          ref={(el) => (frmRef.current["zipcode"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Lat/Long</label>
                        <br />
                        <button
                          type={"button"}
                          id={"billinglatLong"}
                          autoComplete="off"
                          onClick={(e) => {
                            handleLatLong(e);
                          }}
                          ref={(el) => (frmRef.current["billinglatLong"] = el)}
                          className="btn btn-sm btn-warning"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Contact Number(Work)</label>
                        <input
                          type="text"
                          id="work"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["work_contact_number"] = el)
                          }
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Contact Number(whatsapp)</label>
                        <input
                          type="text"
                          id="whatsapp"
                          className="form-control"
                          ref={(el) => (frmRef.current["whatsapp"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Email id</label>
                        <input
                          type="email"
                          id="email_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["email_id"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default CollectionCentersForm;
